<template>
  <ul class="cancel-flow-reasons__list">
    <li v-for="reason in ALL_REASONS" :key="reason.value">
      <button
        type="button"
        class="cancel-flow-reasons__item"
        :disabled="canceling"
        @click="onReasonClick(reason)"
      >
        {{ reason.label }}
      </button>
    </li>
  </ul>

  <div class="cancel-flow-popup__footer">
    <AppButton
      :danger="true"
      :loading="canceling"
      :disabled="canceling"
      class="cancel-flow-popup__cta"
      @click="onEndMembership"
    >
      End my membership
    </AppButton>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'

import AppButton from '@/app/components/button/AppButton.vue'
import { BillingView } from '@/models/billing'
import { ALL_REASONS } from '@/models/billing.cancelFlow'
import type { Reason, ReasonValue } from '@/models/billing.cancelFlow'
import { Mixpanel } from '@/analytics/mixpanel'

const props = defineProps<{
  billing: BillingView
  canceling: boolean
}>()
const emit = defineEmits<{
  (e: 'reasonSelected', reason: ReasonValue): void
  (e: 'continueCancel'): void
}>()

onMounted(() => {
  Mixpanel.trackCancelFlowStepShown(props.billing, 'reasons')
})

function onReasonClick(reason: Reason): void {
  Mixpanel.trackCancelFlowButtonClick(
    props.billing,
    'reasons',
    'reason',
    reason.value,
  )
  emit('reasonSelected', reason.value)
}

function onEndMembership(): void {
  Mixpanel.trackCancelFlowButtonClick(
    props.billing,
    'reasons',
    'end_membership',
  )
  emit('continueCancel')
}
</script>
